"use strict";
/**
 * AngularJS toolbar components.
 *
 * @packageDocumentation
 * @module LoadIndicator
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
//#region Angular Imports
var angular_1 = tslib_1.__importDefault(require("angular"));
//#endregion
//#region DevExtreme Imports
require("devextreme/ui/load_indicator");
//#endregion
var loading_container_component_1 = require("./loading-container.component");
//#region Module Setup
exports.MODULE_NAME = 'imr.controls.components.loading-container';
var module = angular_1.default.module(exports.MODULE_NAME, ['dx']);
module.component(loading_container_component_1.COMPONENT_NAME, new loading_container_component_1.IMRLoadingContainerComponent());
//#endregion
//# sourceMappingURL=loading-container.module.js.map